import { CustomRequestOptions } from '@/interceptors/request'

export const http = <T>(options: CustomRequestOptions) => {
  // 1. 返回 Promise 对象
  return new Promise<IResData<T>>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        const { statusCode } = res
        const { code, msg, message } = res?.data as IResData<T>
        if (statusCode >= 200 && statusCode < 300 && code >= 200 && code < 300) {
          const data = res.data as IResData<T>
          let { data: resData } = data
          if (
            resData &&
            typeof resData === 'object' &&
            'total' in (resData as AnyObject) &&
            'list' in (resData as AnyObject)
          ) {
            resData = (resData as AnyObject).list
          }
          resolve({
            ...data,
            data: resData,
          } as IResData<T>)
        } else if (res.statusCode === 401) {
          // 401错误  -> 清理用户信息，跳转到登录页
          // userStore.clearUserInfo()
          // uni.navigateTo({ url: '/pages/login/login' })
          reject(res)
        } else {
          // const { msg, message } = res.data as IResData<T>
          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast &&
            uni.showToast({
              icon: 'none',
              title: message || msg || '请求错误',
            })
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        uni.showToast({
          icon: 'none',
          title: '网络错误，换个网络试试',
        })
        reject(err)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @returns
 */
export const httpGet = <T>(
  url: string,
  query?: Record<string, any>,
  config?: { token?: string; header?: Record<string, any> },
) => {
  return http<T>({
    url,
    query,
    method: 'GET',
    token: config?.token,
    header: config?.header || {},
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @returns
 */
export const httpPost = <T>(
  url: string,
  data?: Record<string, any>,
  query?: Record<string, any>,
  config?: { token?: string; header?: Record<string, any> },
) => {
  return http<T>({
    url,
    query,
    data,
    method: 'POST',
    token: config?.token,
    header: config?.header || {},
  })
}

http.get = httpGet
http.post = httpPost
